import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, DispatchCompleteLoadSettings } from "@insite/client-framework/Store/Context/Handlers/LoadSettings";
import { getPolicy } from "@store/Framework/Store/Store/Data/getPolicy";

addToChainBefore(chain, DispatchCompleteLoadSettings, props => {
    const state = props.getState();
    if (state.context.isSessionLoaded) {
        const session = getSession(state);
        const canSeePrice = getPolicy(state, "Pricing.CanSeePrice");
        if (!session || (session && !canSeePrice)) {
            let newSettings = {
                ...props.apiResult,
            };
            newSettings.settingsCollection.productSettings.canSeePrices = false;
            props.apiResult = newSettings;
        }
    }
});
